<template>
  <v-row>
    <v-col cols="12" class="mb-1 d-flex justify-end">
      <v-btn
        class="ma-2"
        color="primary"
        :to="{
          name: 'system-admin-folder-add',
          query: currentFolderId ? { parentId: currentFolderId } : {},
        }"
      >
        Add Folder
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
      <v-btn
        class="ma-2"
        color="secondary"
        :to="{
          name: 'system-admin-video-add',
          query: currentFolderId ? { parentId: currentFolderId } : {},
        }"
      >
        Add Video
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
    </v-col>

    <move-dialog ref="moveDialog" @update="navigateToFolder"></move-dialog>

    <!-- <v-col cols="12" class="mb-2">
      <v-text-field
        v-model="searchVal"
        label="Search"
        hide-details
        outlined
        clearable
        append-icon="mdi-magnify"
        @click:append="getDataFromApi()"
        @keydown="checkKeypress"
      />
    </v-col> -->

    <v-col cols="12" style="position: relative;">
      <breadcrumbs
        ref="breadcrumbs"
        mode="link"
        @breadcrumb-click="navigateToFolder"
      ></breadcrumbs>

      <v-switch
        v-model="sortFolders"
        label="Sort mode"
      ></v-switch>
      <v-card>
        <v-data-table
          class="elevation-1"
          :items="folderChildren"
          :loading="loading"
          :headers="table.headers"
          :options.sync="table.options"
        >
          <template #body="props">
            <draggable
              v-show="!loading && folderChildren.length > 0"
              tag="tbody"
              v-model="folderChildren"
              :sort="sortFolders"
              @sort="reorderItems"
            >
              <jump-start-row
                v-for="({ item, isFolder }, index) in folderChildren"
                :key="index"
                :item="item"
                :headers="table.headers"
                :isFolder="isFolder"
                :currentFolderId="currentFolderId"
                @row-drop="moveItem"
                @change-folder="changeFolder({ id: item.id, isFolder })"
                @open="navigateToFolder(isFolder, item.id)"
                @delete="remove(item.id, isFolder)"
              ></jump-start-row>
            </draggable>
            <p class="my-4 text-center" v-if="loading">Loading...</p>
            <p class="my-4 text-center" v-if="!loading && props.items.length == 0">Folder is empty</p>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import draggable from "vuedraggable";
import JumpStartRow from './Row.vue';
import Breadcrumbs from './Breadcrumbs.vue';
import MoveDialog from './MoveDialog.vue';
import {
  getFolderChildren,
  changeVideoParent,
  deleteFolder,
  deleteVideo,
  changeFolderParent,
  changeFolderOrder,
  changeVideoOrder,
} from './api';

export default {
  name: 'ManageJumpStart',
  components: { draggable, JumpStartRow, MoveDialog, Breadcrumbs },
  data: () => ({
    loading: false,
    currentFolderId: null,
    sortFolders: true,
    folderChildren: [],
    table: {
      headers: [
        {
          text: 'Title',
          align: 'start',
          value: 'title',
          width: '150px',
        },
        {
          text: 'Video url',
          value: 'url',
          width: '100px',
        },
        {
          text: 'Last Updated',
          align: 'start',
          value: 'last_updated'
        },
        {
          text: 'Active',
          align: 'start',
          value: 'is_active',
        },
        {
          width: '150px'
        },
      ],
      options: {
        sortBy: ['created_at'],
        sortDesc: [true]
      },
    }
  }),
  computed:{
    breadcrumbs() {
      return this.$refs.breadcrumbs;
    },
  },
  watch: { 
    async '$route.query.folderId'(folderId) {
      await this.setFolder(folderId);
    },
  },
  async mounted() {
    await this.setFolder(this.$route.query.folderId);
  },
  methods: {
    async setFolder(folderId = null) {
      this.loading = true;

      this.currentFolderId = folderId ? parseInt(folderId, 10) : null;
      await this.breadcrumbs.create(this.currentFolderId);
      await this.getChildren(this.currentFolderId);

      this.loading = false;
    },
    async getChildren(folderId = null) {
      this.loading = true;

      const { folders, videos } = await getFolderChildren(folderId);
      const folderItems = folders.map((f) => ({ item: f, isFolder: true }));
      const videoItems = videos.map((v) => ({ item: v, isFolder: false }));
      this.folderChildren = [...folderItems, ...videoItems].sort((a, b) => a.item.order - b.item.order);

      this.loading = false;
    },
    async navigateToFolder(isFolder, folderId) {
      if (isFolder) {
        const query = folderId ? { folderId } : {};
        this.$router.push({ path: 'jump-start', query }).catch((err) => err);
      }
    },
    moveItem({ folderId, dragItem }) {
      const { id, isFolder } = dragItem;
      const change = isFolder ?  changeFolderParent : changeVideoParent;
      this.loading = true;

      change(id, folderId)
        .then(() => this.setFolder(this.$route.query.folderId))
    },
    remove(id, isFolder) {
      console.log('remove');
      const type = isFolder ? 'folder' : 'video';
      const text = {
        title: `Delete ${type}`,
        text: `You are about to delete ${type}. Are you sure to proceed?`,
      };

      this.$swal.fire(text.title, text.text)
        .then(({ isConfirmed }) => {
          if (!isConfirmed) {
            return Promise.resolve();
          } else {
            return this._delete(isFolder, id)
          }
        });
    },
    async reorderItems({ item }) {
      const id = parseInt(item.getAttribute('rowId'), 10);
      const itemIndex = this.folderChildren.findIndex(({ item }) => item.id === id);
      const isFolder = item.hasAttribute('isFolder');

      if (isFolder) {
        await changeFolderOrder(id, itemIndex + 1);
      } else {
        await changeVideoOrder(id, itemIndex + 1); 
      }
    },
    async changeFolder(movableItem) {
      const dialog = this.$refs.moveDialog;
      await dialog.open(movableItem);
    },
    _delete(isFolder, id) {
      this.loading = true;

      return isFolder
        ? deleteFolder(id).then(() => this.setFolder(this.$route.query.folderId))
        : deleteVideo(id).then(() => this.setFolder(this.$route.query.folderId))
    }
  }
}
</script>
